'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MessagesIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function MessagesIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-messages ' + className,
      width: width, height: height,
      viewBox: '0 0 48 48' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M24,7.44192479 C23.6427013,7.44192479 23.2854026,7.55217188 22.9814026,7.77266605 L8.17522078,18.4734629 C7.73205195,18.7934722 7.46753247,19.308609 7.46753247,19.8510637 L7.46753247,38.8535637 C7.46753247,39.7950543 8.24233766,40.5609301 9.19480519,40.5609301 L38.8051948,40.5609301 C39.7576623,40.5609301 40.5324675,39.7950543 40.5324675,38.8535637 L40.5324675,19.8510637 C40.5324675,19.308609 40.2679481,18.7934722 39.8247792,18.4734629 L25.0195844,7.77266605 C24.7145974,7.55217188 24.3572987,7.44192479 24,7.44192479 M38.8051948,43.000025 L9.19480519,43.000025 C6.88223377,43.000025 5,41.1404591 5,38.8535637 L5,19.8510637 C5,18.5329768 5.64254545,17.2812334 6.71937662,16.5036499 L21.5245714,5.8038287 C23.0041039,4.73257825 24.9939221,4.73160261 26.4764156,5.8038287 L41.2806234,16.5036499 C42.3574545,17.2812334 43,18.5329768 43,19.8510637 L43,38.8535637 C43,41.1404591 41.1177662,43.000025 38.8051948,43.000025' }),
      _react2.default.createElement('path', { fill: color, d: 'M24.3276,33.0537 C23.5106,33.0537 22.6946,32.8077 21.9976,32.3147 L11.5286,24.9077 C10.9646,24.5097 10.8306,23.7297 11.2296,23.1657 C11.6286,22.6017 12.4076,22.4677 12.9716,22.8667 L23.4416,30.2737 C23.9716,30.6477 24.6826,30.6487 25.2126,30.2737 L35.5286,22.9767 C36.0916,22.5777 36.8716,22.7107 37.2706,23.2757 C37.6686,23.8387 37.5356,24.6187 36.9716,25.0177 L26.6566,32.3147 C25.9606,32.8067 25.1436,33.0537 24.3276,33.0537' })
    )
  );
}

MessagesIcon.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MessagesIcon/MessagesIcon.js
// module id = 273
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16